import React from 'react';
import './App.css';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import UseSEO from "./Hooks/useSEO";
import getSchemasByRoute from "./SEO/schemaRouter";
import './components/styles/BubbleBackground.css';

import Home from './components/pages/home';
import About from './components/pages/about';
import Contact from './components/pages/contact';
import Services from './components/pages/services';
import Careers from './components/pages/Careers';
import Footer from './components/inc/Footer';




   function App() {
        const location = useLocation();

        // ✅ SEO runs automatically on every route change
       UseSEO({
            schemas: getSchemasByRoute(location.pathname)
        });
    
            
        return (
    
            <main id="main-content">
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/careers" element={<Careers />} />

                    {/* 🔴 Redirect /home → / */}
                    <Route path="/home" element={<Navigate to="/" replace />} />

                </Routes>
                <Footer />
            </main>
   
  );
}
       
export default App;